import { useEffect } from "react";
import { ClipLoader } from "react-spinners";
import { useAppDispatch, useAppSelector } from "../../../../../../app/hooks";
import {
  getExperianPrivateCheckResult,
  selectExperianPrivateSubState,
} from "../../../hyperFlowSlice";
import { HdcReportView } from "./hdc/HdcReportView";

export interface ExperianPrivateCheckComponentProps {
  /** entityId of the executed step = id of the ExperianPrivateCheckResult. */
  entityId: string;
  stepId: string;
}

/** EXPERIAN_PRIVATE_CHECK step: Historia de Crédito+ report. */
export const ExperianPrivateCheckComponent = ({
  entityId,
  stepId,
}: ExperianPrivateCheckComponentProps) => {
  const dispatch = useAppDispatch();
  const { loading, data, error } = useAppSelector(selectExperianPrivateSubState);

  useEffect(() => {
    if (entityId) {
      dispatch(getExperianPrivateCheckResult(entityId));
    }
  }, [dispatch, entityId]);

  if (loading === "idle" || loading === "pending") {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "40px 0",
        }}
      >
        <ClipLoader color="white" size="80px" />
      </div>
    );
  }

  // Guard against a stale result from another step still in the store.
  if (loading === "rejected" || !data || (data.id && data.id !== entityId)) {
    return (
      <div
        className="text-normal text-medium primary-color"
        style={{ padding: "20px 30px" }}
      >
        {error
          ? `No fue posible cargar la consulta de Experian: ${error}`
          : "No hay resultado de Experian para este paso."}
      </div>
    );
  }

  return (
    <HdcReportView
      report={data.response?.ReportHDCplus}
      executionDatetime={data.executionDatetime}
      idPrefix={`hdc-${stepId}`}
    />
  );
};

export default ExperianPrivateCheckComponent;
